// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { EU14_ALLERGEN_OPTIONS } from "@bitebalance/contracts"
import type { I18nContextValue } from "@/i18n"
import { isLactoseLevel, lactoseLevelKey } from "@/lib/constraintClarification"

/** EU-14 allergen ids ↔ onboarding.step6 label keys — ONE vocabulary, shared with mobile through the contracts (ADR-080). */
export const EU14 = EU14_ALLERGEN_OPTIONS

/**
 * Human display for a stored hard-constraint subject. Allergen ids map to
 * their localized EU-14 labels; the structured lactose intolerance shows its
 * user-chosen level; free-text foods render as the user typed them, first
 * letter capitalized. Internal ids never reach the UI raw.
 */
export function constraintChipLabel(
  type: string,
  subjectId: string,
  t: I18nContextValue["t"],
  level?: string
): string {
  if (type === "allergen") {
    const known = EU14.find(e => e.value === subjectId)
    if (known) return t(`onboarding.step6.allergens.${known.labelKey}`)
  }
  if (type === "intolerance" && subjectId === "lactose") {
    const base = t("moreProfile.constraints.intoleranceLactose")
    return isLactoseLevel(level)
      ? `${base} · ${t(`moreProfile.constraints.${lactoseLevelKey(level)}`)}`
      : base
  }
  return subjectId.length === 0 ? subjectId : subjectId[0].toUpperCase() + subjectId.slice(1)
}
